import React from 'react'

const IndexPage: React.FC = () => {
    return (
        <React.Fragment>            
        </React.Fragment>
    )
}

export default IndexPage;